<template>
    <div v-if="dataSource" class="p-relative">
        
        <Toolbar
            v-on:toolbar-button-click="onToolbarClick"  
        />

        <DocumentPanel
            :document-info="dataSource.Data.Object"
        />

        <v-tabs
            v-model="tab"
            background-color="transparent"
            slider-size="3"
            class="tab-selector-panel"
        >
            <v-tabs-slider color="#E43958"></v-tabs-slider>

            <v-tab 
                v-for="item in pages"
                :key="meeting.id + item.FormId"
                @click="onTabClicked(item.FormId)"
            >
                <template v-if="item.Count < 0">
                    {{ item.Name }}
                </template> 
                <template v-else>
                    {{ item.Name }}
                    <span class="count" id="attachCounter">{{ item.Count }}</span>
                </template>   
            </v-tab>

        </v-tabs>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
        
            <v-tab-item 
                v-for="item in pages"
                :key="meeting.id + item.FormId"
            >
                <!-- Карточка -->
                <template v-if="item.FormId == meeting.id">
                    <v-form class="wrapperForm" ref="form" lazy-validation>
                        <v-row dense>
                            
                            <!-- Основная информация -->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                <v-card-panel title="Основная_информация">

                                    <!-- поле Тема -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Тема") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ meeting.Subject }}
                                            </div>                                    
                                            <template v-else>
                                                <v-textarea
                                                    :value="meeting.Subject"
                                                    @input="update({ property: 'Data.Object.Subject', value: $event})"
                                                    rows="3"
                                                    no-resize
                                                    hide-details                                                    
                                                    outlined
                                                    dense
                                                    required
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>
                                            </template>
                                        </v-col>
                                    </v-row>
                                    
                                    <!-- поле Сфера-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Сфера") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ boardNameString }}
                                            </div>
                                            <v-select
                                                v-else
                                                :value="meeting.BoardId"
                                                @input="update({ property: 'Data.Object.BoardId', value: $event})"
                                                :items="boards"
                                                :item-text="item => $i18n.locale == 'kk' ? item.name['kk-KZ'] : item.name['ru-RU']"
                                                item-value="id"
                                                hide-details
                                                required
                                                :rules="requiredRule.concat(noDefaultGuidRule)"
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <!-- поле Категория-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Категория") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ categoriesString }}
                                            </div>
                                            <v-select
                                                v-else
                                                :value="meeting.Categories"
                                                @input="update({ property: 'Data.Object.Categories', value: $event})"
                                                :items="meetingCategories"
                                                multiple
                                                clearable
                                                :item-text="item => $t(item.Value)"
                                                item-value="id"
                                                hide-details
                                                required
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                </v-card-panel>
                            </v-col>

                            <!-- Сроки-->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                <v-card-panel title="Сроки">
                                    
                                    <!-- поле Месяц-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Месяц") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ monthString }}
                                            </div>
                                            <v-select
                                                v-else
                                                :value="meeting.Month"
                                                @input="onMonthInput"
                                                :items="meetingMonths"
                                                :item-text="item => $t(item.Value)"
                                                item-value="id"
                                                hide-details
                                                required
                                                :rules="requiredRule.concat(integerNotNull)"
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <!-- поле Год-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Год") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ meeting.Year }}
                                            </div>
                                            <v-select
                                                v-else
                                                :value="meeting.Year"
                                                @input="onYearInput"
                                                :items="meetingYears"
                                                hide-details
                                                required
                                                :rules="requiredRule.concat(integerNotNull)"
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <!-- поля Период проведения -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Период_проведения") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ fromDay }} - {{ toDay }}
                                            </div>
                                            <div class="more-inputs-in-row" v-else>
                                                <v-text-field
                                                    type="number"
                                                    :value="fromDay"
                                                    @input="onFromDayInput"
                                                    outlined
                                                    dense
                                                    required
                                                    :rules="getFromDateRules()"
                                                    :readonly="!meeting.Month"
                                                >
                                                </v-text-field>
                                                <span>-</span>
                                                <v-text-field
                                                    type="number"
                                                    :value="toDay"
                                                    @input="onToDayInput"
                                                    outlined
                                                    dense
                                                    required
                                                    :rules="getToDateRules()"
                                                    :readonly="!meeting.Month"
                                                >
                                                </v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <!-- Фактический срок -->
                                    <v-row v-if="!meeting.is_new_record" no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Фактический_срок") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ meetingRealDate ? formatDate(meetingRealDate) : $t('не_указано') }}
                                            </div>
                                            <template v-else>
                                                <v-menu 
                                                    v-model="meetingRealDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="meetingRealDate | formattedDate"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on" 
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            clearable
                                                            @click:clear="updateSource({ property: 'Data.Object.RealDate', value: null })"
                                                            class="datepick-input"
                                                        >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="meetingRealDate"
                                                        @input="meetingRealDateMenu = false"
                                                        color="teal"
                                                        :first-day-of-week="1"
                                                    >
                                                    </v-date-picker>
                                                </v-menu>

                                            </template>
                                        </v-col>
                                    </v-row>

                                </v-card-panel>
                            </v-col>

                            <!-- Ответственные -->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                <v-card-panel title="Ответственные">

                                    <!-- поле Ответственное управление -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Ответственное_управление") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ meeting.ResponsibleEnterpriseName ? meeting.ResponsibleEnterpriseName : $t("не_указано") }}
                                            </div>
                                            <template v-else>
                                                <v-text-field
                                                    class="prepend-icon-tf"
                                                    :readonly="responsibleEnterpriseReadonly"
                                                    :value="meeting.ResponsibleEnterpriseName"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    @input="onResponsibleEnterpriseInput"
                                                    clearable
                                                    @click:clear="onResponsibleEnterpriseClear"
                                                    :append-icon="responsibleEnterpriseReadonly ? 'mdi-dots-horizontal' : ''"
                                                    @click:append="onResponsibleEnterpriseSelect"
                                                >
                                                    <!--
                                                    <template v-slot:prepend>
                                                        <div class="v-input__icon v-input__icon--prepend">
                                                            <v-icon
                                                                @click="onResponsibleEnterpriseReadonlyToggle"  
                                                                v-tooltip.top-center="responsibleEnterpriseReadonly ? $t('Ввести_вручную') : $t('Выбрать_из_списка')"  
                                                            >
                                                                {{ responsibleEnterpriseReadonly ? 'mdi-pencil-plus' : 'mdi-menu' }}
                                                            </v-icon>
                                                        </div>
                                                    </template>
                                                    -->
                                                </v-text-field>
                                            </template>
                                        </v-col>
                                    </v-row>

                                    <!-- поле Ответственный специалист -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Ответственный_специалист") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div class="icon-click-row-group icrg-align-center">

                                                <div v-if="!isViewMode" @click="onControllerSelect" :key="meeting.ControllerWorkplaceId">
                                                    <v-icon small v-tooltip.left-center="$t('Выбрать_ответственного_специалиста')">
                                                        fas fa-edit
                                                    </v-icon>
                                                </div>
                                                
                                                <div class="onlyReadData">
                                                    <v-workplace-chip 
                                                        v-if="meeting.ControllerName" 
                                                        :id="meeting.ControllerWorkplaceId"
                                                        :name="meeting.ControllerName"
                                                        :canDelete="!isViewMode"
                                                        :delFunc="onRemoveController"
                                                    />
                                                    <template v-else>
                                                        <v-select-members-chip 
                                                            v-if="!isViewMode"
                                                            target-type="Member"
                                                            @on-select="onControllerSelectChip"
                                                            :items-params="membersControllerSelectParams"
                                                            :required="false"
                                                        />
                                                        <template v-else>
                                                            {{ $t("не_указано") }}
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <!-- поле Контролирующий -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Контролирующий") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div class="icon-click-row-group icrg-align-center">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ sanitizeName(meeting.CuratorName) }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="meeting.CuratorWorkplaceId"
                                                    @input="onCuratorSelect"
                                                    :items="curators"
                                                    :item-text="item => sanitizeName(item.name)"
                                                    item-value="id"
                                                    hide-details
                                                    outlined
                                                    dense
                                                    clearable
                                                    return-object
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                </v-select>
                                            </div>
                                        </v-col>
                                    </v-row>

                                </v-card-panel>
                            </v-col>
                            
                            <!-- Кем создано-->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                <v-card-panel title="Кем_создано">
                                    
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Сотрудник") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div class="onlyReadData">
                                                <v-employee-chip :id="meeting.AuthorEmployeeId" :name="meeting.AuthorName" />
                                            </div>
                                        </v-col>
                                    </v-row>
                                    
                                    <v-row no-gutters v-if="meeting.EnterpriseId">
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Организация") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div class="onlyReadData">
                                                <v-enterprise-chip :id="meeting.EnterpriseId" :name="$i18n.locale == 'kk' ? meeting.EnterpriseName['kk-KZ'] : meeting.EnterpriseName['ru-RU']" />
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters v-if="meeting.CreateDate">
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Дата_создания")}}</label>
                                        </v-col>
                                        <v-col  cols="12" sm="12" md="8">
                                            <div class="onlyReadData">{{ formatDate(meeting.CreateDate) }}</div>
                                        </v-col>
                                    </v-row>

                                </v-card-panel>
                            </v-col>

                            <v-col v-if="!meeting.is_new_record" cols="12" sm="12" md="12" class="section-wrapper">                               

                                <!-- Итоги -->
                                <v-card-panel title="Итоги">
                                    <v-row class="full-width-row" no-gutters>
                                        <v-col cols="12" sm="12" md="2">
                                            <label class="f-label">{{ $t("Итоги") }}</label>
                                        </v-col>
                                        <v-col  cols="12" sm="12" md="10">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ meeting.Results ? meeting.Results : $t("не_указано") }}
                                            </div>
                                            <v-textarea
                                                v-else
                                                :value="meeting.Results"
                                                @input="update({ property: 'Data.Object.Results', value: $event})"
                                                rows="3"
                                                no-resize
                                                hide-details
                                                outlined
                                                dense
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card-panel>

                                <!-- Вложения -->
                                <AttachmentsPanel /> 
                                
                            </v-col>

                        </v-row>
                    </v-form>
                </template>

                <template v-else>
                    <component
                        :is="$mapComponent(item.FormId)"
                        :ref="item.FormId"
                        :id="meeting.id"
                    />
                </template>
            </v-tab-item>
        </v-tabs-items>

    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import sys from "@/services/system";
import { httpAPI } from "@/api/httpAPI";
import Toolbar from '@/components/documents/Toolbar.vue';
import DocumentPanel from '@/components/documents/DocumentPanel.vue';
import AttachmentsPanel from '@/components/eds-light/AttachmentsPanel.vue';

export default {
    name: "PlannedMeeting",
    components: {
        Toolbar,
        DocumentPanel,
        AttachmentsPanel
    },
    data() {
        return {
            tab: null,

            boardSearch: null,
            curators: [],

            currentMonthMaxDate: 31,
            meetingRealDateMenu: false,

            //для выбора режима вводы 
            responsibleEnterpriseReadonly: true,
        }
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    asyncComputed: {
        boards : {
            async get() {
                let url = this.meeting.is_new_record ? `api/plannedevent/boardlist` : `api/plannedevent/boardlist?filter=${JSON.stringify({ Enterprise: this.enterprise })}`;
                let boardsResponse = await httpAPI({ url, method: 'GET' });
                let tmp = boardsResponse?.data?.Payload ?? [];
                return this.boardSearch ? tmp.filter(x => sys.checkSearch(x.name, this.boardSearch) || x.id == this.meeting.BoardId) : tmp;
            },
            default: [],
            watch: ['boardSearch']
        }
    },
    computed: {
        ...mapGetters('global/actionsource', { dataSource: 'getDataSource', dataSourceType: 'getDataSourceType', isNew: 'isDataSourceNewRecord' }),
        ...mapGetters({ requiredRule: 'getRequiredRule', integerNotNull: 'getIntegerNotNullRule', noDefaultGuidRule: 'getDefaultGuidRule' }),
        ...mapGetters('planner', { meetingCategories: 'getMeetingCategories', meetingMonths: 'getMeetingMonths', meetingYears: 'getMeetingYears', enterprise: 'getFilterEnterprise' }),
        membersControllerSelectParams() {
            return { 
                title: this.$t('Выбрать_ответственного_специалиста'),
                includeInner: true,
                includeOuter: true,
                multiple: false,
                selected: this.meeting?.ControllerWorkplaceId ? [ this.meeting?.ControllerWorkplaceId ] : []
            };
        },
        /*membersCuratorSelectParams() {
            return { 
                title: this.$t('Выбрать_курирующего_специалиста'),
                includeInner: true,
                includeOuter: false,
                multiple: false,
                selected: this.meeting?.CuratorWorkplaceId ? [ this.meeting?.CuratorWorkplaceId ] : []
            };
        },*/
        isViewMode() {
            return this.dataSource?.Data?.FormId == "1901021";
        },
        meeting() {
            return this.dataSource?.Data?.Object;
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.meeting.id, Name: this.$t("Мероприятие") },
            ];
            if (!this.isNew){
                pages.push({ Count: -1, FormId: "0202150" , Name: this.$t("Комментарии") });
                pages.push({ Count: -1, FormId: "0202060" , Name: this.$t("История") });
            }
            return pages;
        },
        //#region View
        boardNameString() {
            let board = this.boards.find(x => x.id == this.meeting.BoardId);

            if (!board)
                return this.$t("не_указано");

            return this.$i18n.locale == 'kk' ? board.name['kk-KZ'] : board.name['ru-RU'];
        },
        categoriesString() {
            if (!this.meeting.Categories)
                return this.$t("не_указано");

            let result = [];

            this.meetingCategories.forEach((c) => {
                if (this.meeting.Categories.includes(c.id))
                    result.push(c.Value);
            });

            if (result.length == 0)
                return this.$t("не_указано");

            return result.join(", ");
        },
        monthString() {
            let month = this.meetingMonths.find(x => x.id == this.meeting.Month);

            if (!month)
                return this.$t("не_указано");

            return this.$t(month.Value);
        },
        //#endregion
        //#region Даты, интервалы
        fromDay() {
            return this.meeting.FromDay > 0 ? this.meeting.FromDay : null;
        },
        toDay() {
            return this.meeting.ToDay > 0 ? this.meeting.ToDay : null;
        },
        meetingRealDate: {
            get: function() {
                if (this.meeting.RealDate){
                    return this.$moment(this.meeting.RealDate).format('YYYY-MM-DD');
                }
                
                return this.meeting.RealDate;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.RealDate', value: `/Date(${Date.parse(newValue)})/` });
            }
        }
        //#endregion
    },
    methods: {
        ...mapActions('global/actionsource', { updateSource: 'updateDataSource' }),
        ...mapActions('planner', { getCurators: 'getCurators' }),
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },
        sanitizeName(source) {
            return sys.sanitizeName(source);
        },
        async onToolbarClick(event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('global/actionsource/')).map(i => {return i.split('/')[2]})
            
            if (actions.includes(button.Action)) {
                if (button.Action == 'Save' || button.Action == 'SaveAndClose') {
                    let validate_result = this.$refs.form[0].validate();
                    
                    if (validate_result) {
                        await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
                        this.$eventBus.$emit('update-boardcounter');        
                    }
                    else {
                        this.$notify.alert(this.$t("Не_заполнены_обязательные_поля"));
                    }
                }
                else {
                    await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
                }
            }
            else
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
        },
        onTabClicked() {

        },
        onMonthInput(v) {
            this.updateSource({ property: 'Data.Object.Month', value: v});
            this.updateMinMaxDays();
        },
        onYearInput(v){
            this.updateSource({ property: 'Data.Object.Year', value: v});
            this.updateMinMaxDays();
        },
        updateMinMaxDays(){
            if (this.meeting.Year && this.meeting.Month){
                let month = String(this.meeting.Month).padStart(2, "0");
                let minDay = 1;
                this.currentMonthMaxDate = this.$moment(`${this.meeting.Year}-${month}`, "YYYY-MM").daysInMonth();
                this.updateSource({ property: 'Data.Object.FromDay', value: minDay });
                this.updateSource({ property: 'Data.Object.ToDay', value: this.currentMonthMaxDate });
            }
        },
        onFromDayInput(v) {
            this.updateSource({ property: 'Data.Object.FromDay', value: Number(v) });
            this.$refs?.form?.[0]?.validate();
        },
        onToDayInput(v) {
            this.updateSource({ property: 'Data.Object.ToDay', value: Number(v) });
            this.$refs?.form?.[0]?.validate();
        },
        getFromDateRules() {
            return [
                v => !!v || this.$t('Обязательное_поле'),
                v => ( v > 0 ) || this.$t('Значение_не_может_быть_меньше_или_равно_нулю'),
                v => ( v <= this.meeting.ToDay ) || this.$t('Слишком_большое_значение'),
                v => ( v < this.currentMonthMaxDate) || this.$t('Слишком_большое_значение')                
            ];
        },
        getToDateRules() {
            return [
                v => !!v || this.$t('Обязательное_поле'),
                v => ( v >= this.meeting.FromDay ) || this.$t('Слишком_маленькое_значение'),
                v => ( v <= this.currentMonthMaxDate ) || this.$t('Слишком_большое_значение')
            ];
        },
        onResponsibleEnterpriseReadonlyToggle() {
            this.updateSource({ property: 'Data.Object.ResponsibleEnterpriseName', value: null });
            this.updateSource({ property: 'Data.Object.ResponsibleEnterpriseId', value: null });
            this.responsibleEnterpriseReadonly = !this.responsibleEnterpriseReadonly;
        },
        onResponsibleEnterpriseInput(value) {
            this.updateSource({ property: 'Data.Object.ResponsibleEnterpriseName', value });
            this.updateSource({ property: 'Data.Object.ResponsibleEnterpriseId', value: null });
        },
        async onResponsibleEnterpriseSelect() {
            try {
                let enterprise = await this.$store.dispatch('global/dialogs/selectEnterprise/open', {multyselect: false, selected: [this.meeting.ResponsibleEnterpriseId]});    
                this.updateSource({ property: 'Data.Object.ResponsibleEnterpriseName', value: enterprise.name });
                this.updateSource({ property: 'Data.Object.ResponsibleEnterpriseId', value: enterprise.id });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        onResponsibleEnterpriseClear() {
            this.updateSource({ property: 'Data.Object.ResponsibleEnterpriseName', value: null });
            this.updateSource({ property: 'Data.Object.ResponsibleEnterpriseId', value: null });
        },
        async onControllerSelect() {
            try
            {
                let { workplaceId, employeeId, name } = await this.$store.dispatch('global/dialogs/selectMembersNew/open', this.membersControllerSelectParams);
                this.updateSource({ property: `Data.Object.ControllerWorkplaceId`, value: workplaceId });
                this.updateSource({ property: `Data.Object.ControllerEmployeeId`, value: employeeId });
                this.updateSource({ property: `Data.Object.ControllerName`, value: name });

            }
            catch(ex)
            {
                if (ex.message != "Cancelled")
                    console.error("Произошла непредвиденная ошибка");
                else
                    console.log("Cancelled");
            }
        },
        onControllerSelectChip(e) {
            this.updateSource({ property: `Data.Object.ControllerWorkplaceId`, value: e.value.workplaceId });
            this.updateSource({ property: `Data.Object.ControllerEmployeeId`, value: e.value.employeeId });
            this.updateSource({ property: `Data.Object.ControllerName`, value: e.value.name });
        },
        onRemoveController() {
            this.updateSource({ property: `Data.Object.ControllerWorkplaceId`, value: null });
            this.updateSource({ property: `Data.Object.ControllerEmployeeId`, value: null });
            this.updateSource({ property: `Data.Object.ControllerName`, value: null });
        },
        async onCuratorSelect(curator) {
            this.updateSource({ property: 'Data.Object.CuratorWorkplaceId', value: curator?.id});
            this.updateSource({ property: `Data.Object.CuratorEmployeeId`, value: curator?.employeeid });
            this.updateSource({ property: `Data.Object.CuratorName`, value: curator?.name });
        },
        update: _.debounce(function (object) {
            this.updateSource(object);
        }, 250)
    },
    async created() {
        (async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            if (!this.isViewMode && this.meeting.is_new_record) {
                let creationBag = this.$store.getters['planner/getCreationBag'];
                
                if (creationBag) {
                    this.onYearInput(creationBag.year);
                    this.onMonthInput(creationBag.month);
                    this.updateSource({ property: 'Data.Object.BoardId', value: creationBag.board});
                }
            }

            this.$refs?.form?.[0]?.validate();
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs?.form?.[0]?.validate();
        }
    },
    async mounted(){
        this.curators = await this.$store.dispatch('planner/getCurators');
    }
}
</script>